import styled from 'styled-components';

export const Container = styled.div.attrs({ className: 'container' })`
  padding-top: 2em;
`;
